import { render } from "./material-details.vue?vue&type=template&id=44841c1a&ts=true"
import script from "./material-details.vue?vue&type=script&lang=ts"
export * from "./material-details.vue?vue&type=script&lang=ts"

import "./material-details.vue?vue&type=style&index=0&id=44841c1a&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__